
function loadItems(nextUrl, onDone) {
  fetch(nextUrl)
    .then(res => res.text())
    .then(data => {
      let parser = new DOMParser();
      let htmlDoc = parser.parseFromString(data, "text/html");

      let newItems = htmlDoc.querySelectorAll(".load-item");
      let container = document.querySelector(".load-wrapper");
      newItems.forEach(item => container.appendChild(item));

      if (typeof onDone === "function") {
        onDone(htmlDoc);
      }
    });
}

// ---------- Loadmore button ----------
document.addEventListener("click", function (e) {
  if (e.target.matches(".btn-loadmore")) {
    let btn = e.target;
    let nextUrl = btn.getAttribute("data-next-url");
    let wrapPagi = document.querySelector(".loadmore-wrap");
    if (!nextUrl) return;
    btn.classList.add("load");
    loadItems(nextUrl, function (htmlDoc) {
      let newNext = htmlDoc.querySelector(".btn-loadmore");
      if (newNext && newNext.getAttribute("data-next-url")) {
        btn.setAttribute("data-next-url", newNext.getAttribute("data-next-url"));
        btn.classList.remove("load");
      } else {
        btn.remove();
        wrapPagi.remove();
      }
      events();
    });
  }
});

// ---------- Infinite scroll ----------
let trigger = document.querySelector(".infinite-scroll-trigger");
if (trigger) {
  let observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let nextUrl = trigger.getAttribute("data-next-url");
        let wrapPagi = document.querySelector(".infinite-wrap");
        if (!nextUrl) return;

        loadItems(nextUrl, function (htmlDoc) {
          let newTrigger = htmlDoc.querySelector(".infinite-scroll-trigger");
          if (newTrigger && newTrigger.getAttribute("data-next-url")) {
            trigger.setAttribute("data-next-url", newTrigger.getAttribute("data-next-url"));
          } else {
            trigger.remove();
            wrapPagi.remove();
            observer.disconnect();
          }
        });
        events();
      }
    });
  }, { threshold: 1.0 });

  observer.observe(trigger);
}

function events() {
  clickColors();
  addcart();
  compare();
  S00601CartProduct.wishlist();
  S00601CartProduct.quickView();
  products.loadWishlistFromStorage(); 
  products.loadWishlist();
  products.loadCompared(); 
  products.clearWishlist(); 
  products.changeColor();
}

function addcart() {
  $('.card-product .addcart, .card-product .btn-add-cart').each(function () {
    $(this).off('click').on('click', function () {
      var variantId = $(this).parents('.card-product').find('.colorItem.active').data('id');
      const quantity = 1;
      if (variantId == undefined)
        variantId = $(this).parents('.card-product').data('productid');

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: quantity,
          id: variantId
        },
        dataType: 'json',
        success: function () {
          products.loadIconCart();
          $('.open-cart').trigger('click');
          setTimeout(function() {
            $('.tf-minicart-recommendations').addClass('open');
          }, 800);
        },
        error: function (err) {
          alert('Add to cart failed.');
          console.error(err);
        }
      });
    })
  })
}

function compare() {
  $('.card-product .compare').each(function () {
    $(this).off('click').on('click', function () {
      const $card = $(this).closest('.card-product');
      const productId = $card.find('.colorItem.active').data('id') || $card.data('productid');
      const img = $card.find('.colorItem.active').data('img') || $card.find('.image-wrap img:first').attr('src');
      const url = $card.find('.image-wrap').attr('href') + (productId ? `?variant=${productId}` : '');

      if (!productId) return;

      let dataUser = JSON.parse(localStorage.getItem("dataUser") || '{}');

      if (!dataUser.randomId) {
        dataUser = {
          id: typeof customerId !== "undefined" ? customerId : "",
          randomId: themeName + products.generateRandomString(100),
          dataWishlist: [],
          dataCompare: []
        };
      }

      const exists = dataUser.dataCompare?.some(item => item.id == productId);

      if (exists) {
        dataUser.dataCompare = dataUser.dataCompare.filter(item => item.id != productId);
        $(`.tf-sidebar-compare .item[data-id="${productId}"]`).remove();
        $card.removeClass('compared');
        $(this).find('.box-icon.compare .icon_wrap').html('<span class="icon icon-compare"></span>');
        var tooltipDelete = $(this).find('.box-icon.compare').data('tooltip');
        $(this).find('.box-icon.compare .tooltip').text(tooltipDelete);
        if (!$('.tf-sidebar-compare .item').length) $('.tf-sidebar-compare.active').removeClass('active');;
      } else {
        dataUser.dataCompare = [...(dataUser.dataCompare || []), { id: productId, img, url }];
        $('.tf-sidebar-compare .content').append(`
          <div class="item" data-id="${productId}">
            <span class="remove">
              <span class="icon icon-close"></span>
            </span>
            <a href="${url}" title=""><img src="${img}" alt=""></a>
          </div>`);
        $card.addClass('compared');
        $(this).find('.box-icon.compare .icon_wrap').html('<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 48 48" width="24"><g fill="currentColor"><path d="m39 6h-9v-1a3 3 0 0 0 -3-3h-7a3 3 0 0 0 -3 3v1h-8a3 3 0 0 0 -3 3v2a3 3 0 0 0 2.025 2.824l.854 27.332a4.977 4.977 0 0 0 5 4.844h20.244a4.977 4.977 0 0 0 5-4.844l.854-27.332a3 3 0 0 0 2.023-2.824v-2a3 3 0 0 0 -3-3zm-20-1a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1h-9zm18.122 36.094a2.987 2.987 0 0 1 -3 2.906h-20.245a2.987 2.987 0 0 1 -3-2.906l-.845-27.094h27.936zm2.878-30.094a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1v-2a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1z"/><path d="m24 19a1 1 0 0 0 -1 1v18a1 1 0 0 0 2 0v-18a1 1 0 0 0 -1-1z"/><path d="m31.028 19a.972.972 0 0 0 -1.028.972l-.5 18a1 1 0 0 0 .972 1.028h.028a1 1 0 0 0 1-.972l.5-18a1 1 0 0 0 -.972-1.028z"/><path d="m16.972 19a1 1 0 0 0 -.972 1.028l.5 18a1 1 0 0 0 1 .972h.028a1 1 0 0 0 .972-1.028l-.5-18a1 1 0 0 0 -1.028-.972z"/></g></svg>');
        var tooltipDelete = $(this).find('.box-icon.compare').data('tooltip-delete');
        $(this).find('.box-icon.compare .tooltip').text(tooltipDelete);
        $('.tf-sidebar-compare').addClass('active');
      }

      localStorage.setItem("dataUser", JSON.stringify(dataUser));
      S00801SidebarCompare.init();
    })
  })
}

function clickColors() {
  $('.card-product .colorItem').each(function () {
    $(this).off('click').on('click', function () {
      $(this).addClass('active').siblings().removeClass('active');
      var _i = $(this).data('index');
      $('.card-product .cartProduct__prices .price').eq(_i).addClass('active').siblings().removeClass('active');
    })
  })
}